import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia",
    label: "Asistencia",
    isActive: true,
  },
];

function Asistencia() {
  return (
    <Page
      title="Asistencia"
      description="Control y proyecciones de asistencia."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Asistencia;
